"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROPERTY_CARD_APPEARANCES = void 0;
var PROPERTY_CARD_APPEARANCES = Object.freeze({
  LARGE: 'large',
  SMALL: 'small',
  HORIZONTAL: 'horizontal',
  FLAG: 'flag'
});
exports.PROPERTY_CARD_APPEARANCES = PROPERTY_CARD_APPEARANCES;